import { render, staticRenderFns } from "./GerkonStatus.vue?vue&type=template&id=e2e699ce&scoped=true&"
import script from "./GerkonStatus.vue?vue&type=script&lang=js&"
export * from "./GerkonStatus.vue?vue&type=script&lang=js&"
import style0 from "./GerkonStatus.vue?vue&type=style&index=0&id=e2e699ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e699ce",
  null
  
)

export default component.exports